module.exports = __webpack_public_path__ + "img/almaty5.93e4d596.jpg";